import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ConfirmModalData } from './modal.interface';

export interface ModalState {
   showConfirmModal: boolean;
   confirmModalData?: ConfirmModalData;
}

const Store: Module<ModalState, StoreState> = {
   namespaced: true,
   state: {
      showConfirmModal: false,
   },
   getters: {},
   mutations: {
      SET_SHOW_CONFIRM_MODAL: (state, showConfirmModal: boolean) => {
         state.showConfirmModal = showConfirmModal;
      },
      SET_CONFIRM_MODAL_DATA: (state, confirmModalData?: ConfirmModalData) => {
         state.confirmModalData = confirmModalData;
      },
   },
   actions: {
      promptConfirmation(context, confirmModalData: ConfirmModalData) {
         context.commit('SET_SHOW_CONFIRM_MODAL', true);
         context.commit('SET_CONFIRM_MODAL_DATA', confirmModalData);
      },
      closeConfirmation(context) {
         context.commit('SET_SHOW_CONFIRM_MODAL', false);
         context.commit('SET_CONFIRM_MODAL_DATA', null);
      },
   },
};

export default Store;
